// ============================================================
// MetalMuse business details — every button, link, form and
// map on the site reads from this single file.
// ============================================================
export const SITE = {
  name: "MetalMuse",
  tagline: "Your Memories. Made to Last.",
  whatsappNumber: "16395258969",
  messengerUrl: "https://m.me/metalmuseca",
  facebookUrl: "https://facebook.com/metalmuseca",
  instagramUrl: "https://instagram.com/metalmuse.ca",
  email: "theoutlaws.chatgpt@gmail.com",
  phoneDisplay: "+1 (639) 525-8969",
  region: "Regina, Saskatchewan, Canada",
  address: "120-2339 Willow Road, Regina, SK S4V 4C1",
  mapsQuery: "120-2339 Willow Road, Regina, SK S4V 4C1",
  // Google Reviews badge on the homepage. Rating/count are shown once the
  // profile has reviews; until then the badge invites first reviewers.
  googleReviewUrl: "https://share.google/kTN0iLRUE7K9J6LD7",
  googleRating: 5.0,
  googleReviewCount: 0,
};

export const waLink = (message) =>
  `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(message)}`;

export const messengerLink = SITE.messengerUrl;

export const mailtoLink = (subject, body) =>
  `mailto:${SITE.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
